import {Directive, ElementRef, Renderer2} from '@angular/core';

/**
 * Generated class for the BlackDirective directive.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 * for more info on Angular Directives.
 */
@Directive({
  selector: '[black]' // Attribute selector
})
export class BlackDirective {

  constructor(public element: ElementRef, public renderer: Renderer2) {
  }

  ngOnInit(){
    this.element.nativeElement.addClassName("black");
  }

}



// WEBPACK FOOTER //
// ./src/directives/black/black.ts